import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-edit-sku",
  "use": "icon-edit-sku-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-edit-sku\"><defs><style type=\"text/css\"></style></defs><path d=\"M870.346248 870.423037H153.653752V153.73054h412.098185l102.384643-102.384642H51.26911v921.461781h921.46178V355.940209l-102.384642 102.384642V870.423037z\" p-id=\"2093\" /><path d=\"M300.06379 724.012998l180.708894-35.834625 398.276259-398.276258-144.874269-144.874269-397.764336 398.276258-36.346548 180.708894zM770.367645 108.527721l108.630105-108.527721 144.771885 144.771884-108.578914 108.527721z\" p-id=\"2094\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/edit-sku.svg
// module id = riyh
// module chunks = 118